import { inject, Injectable, signal } from '@angular/core';
import { AdaService } from '@core/ada/services/ada.service';
import { catchError, EMPTY, finalize, takeUntil, tap } from 'rxjs';
import { AuthorizationService } from '@core/authorization/services/authorization.service';

@Injectable({
  providedIn: 'root',
})
export class AdaTokenFacade {
  private readonly adaService = inject(AdaService);
  private readonly authorizationService = inject(AuthorizationService);
  private readonly adaTokenSignal = signal<string | undefined>(undefined);
  private readonly isTokenLoadingSignal = signal(false);

  readonly adaToken = this.adaTokenSignal.asReadonly();
  readonly isTokenLoading = this.isTokenLoadingSignal.asReadonly();

  loadToken(): void {
    this.isTokenLoadingSignal.set(true);
    this.adaService
      .getAdaToken()
      .pipe(
        takeUntil(this.authorizationService.onLogout),
        tap(({ accessToken }) => this.adaTokenSignal.set(accessToken)),
        catchError(() => {
          this.clearToken();
          return EMPTY;
        }),
        finalize(() => this.isTokenLoadingSignal.set(false))
      )
      .subscribe();
  }

  clearToken(): void {
    this.adaTokenSignal.set(undefined);
  }
}
